import { CSSProperties, ReactNode } from "react";

export interface CommandCardSlot {
    key:      string;
    label?:   string;
    color?:   string;
    icon?:    ReactNode;
    active?:  boolean;
}

interface CommandCardProps {
    modeSlots?: ( CommandCardSlot | null )[];
    cmdSlots?:  ( CommandCardSlot | null )[];
    onSelect:   ( slot: CommandCardSlot ) => void;
}

//these are really just for reference
const modeKeys = [ "2", "3", "4", "5", "6", ];

const keys = [
    "Q", "W", "E", "R", "T",
    "A", "S", "D", "F", "G",
    "Z", "X", "C", "V", "B",
];

const gridStyle: CSSProperties = {
    display:             "grid",
    gridTemplateColumns: "repeat(5, 52px)",
    gridTemplateRows:    "repeat(4, 52px)",
    gap:                 "0.15em",
};

const cellStyle: CSSProperties = {
    // border:       "2px white solid",
    // borderRadius: "0.25em",
};

const hotkeyStyle = ( color: string ): CSSProperties => ( {
    top:      "0px",
    left:     "0px",
    fontSize: 10,
    color:    color,
} );

const labelStyle = ( color: string ): CSSProperties => ( {
    fontFamily: "monospace",
    fontSize:   "0.75em",
    color:      color,
} );

function contrastColor( bg?: string ): string {
    const dark = ["black", "brown", "purple", "blue"];
    return dark.includes( bg?.toLowerCase() ?? "" )
        ? "rgba( 255, 255, 255, 0.90)"
        : "rgba(   0,   0,   0, 0.75)";
}

const panelStyle: CSSProperties = {
    bottom:               "0px",
    left:                 "0px",
    zIndex:               10,
    borderRadius:         "0px 7px 0px 0px",
    background:           "rgba(255, 255, 255, 0.65)",
 // backdropFilter:       "blur(12px)",
 // WebkitBackdropFilter: "blur(12px)",
    border:               "1px solid rgba(255, 255, 255, 0.2)",
};

interface KeyCellProps {
    hotkey:   string;
    slot:     CommandCardSlot;
    onSelect: ( slot: CommandCardSlot ) => void;
}

function KeyCell( { hotkey, slot, onSelect }: KeyCellProps ) {
    const color = contrastColor( slot.color );
    const flexCls   = `d-flex flex-column align-items-center justify-content-center`;
    const borderCls = `border border-2 ${slot.active ? "border-primary" : "border-black"}`;
    const cls       = `position-relative ${flexCls} rounded-2 ${borderCls} shadow`;
    return <div
        role="button"
        className={cls}
        style={{ ...cellStyle, backgroundColor: slot.color ?? "#2A2A2E" }}
        title={slot.label}
        onClick={() => onSelect( slot )}>
        <span
            className="position-absolute ms-1 font-monospace fw-bold"
            style={hotkeyStyle( color )}>
            {hotkey}
        </span>
        <small
            className="fw-semibold"
            style={labelStyle( color )}>
            {slot.icon ?? slot.label}
        </small>
    </div>;
}

export function CommandCard( { modeSlots, cmdSlots, onSelect }: CommandCardProps ) {
    return <div className="position-absolute p-2 shadow border-top border-start" style={panelStyle}>
        <div style={gridStyle}>
            {modeSlots && modeKeys.map( ( key, i ) => {
                const slot = modeSlots[i];
                if( !slot ) {
                    return <div key={key} />;
                }
                return <KeyCell key={key} hotkey={slot.key} slot={slot} onSelect={onSelect} />;
            } )}
            {cmdSlots && keys.map( ( key, i ) => {
                const slot = cmdSlots[i];
                if( !slot ) { return <div key={key} />; }
                return <KeyCell key={key} hotkey={key} slot={slot} onSelect={onSelect} />;
            } )}
        </div>
    </div>;
}